module.exports = __webpack_public_path__ + "img/bad-session-2.049dfbca.png";